import {
  Area,
  AreaChart,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  ReferenceLine,
  ComposedChart,
} from "recharts";

export default function PriceChart({ bars = [], positive = true, tech }) {
  if (!bars.length) {
    return <div className="h-72 flex items-center justify-center text-zinc-600 text-xs">No data</div>;
  }
  const data = bars.map((b) => ({
    t: b.t?.slice(0, 10),
    price: b.c,
  }));
  const color = positive ? "#00FF66" : "#FF3B30";
  const sma20 = tech?.indicators?.sma20;
  const sma50 = tech?.indicators?.sma50;
  return (
    <ResponsiveContainer width="100%" height={320}>
      <ComposedChart data={data} margin={{ top: 8, right: 16, bottom: 0, left: 0 }}>
        <CartesianGrid stroke="#27272a" strokeDasharray="0" vertical={false} />
        <XAxis
          dataKey="t"
          stroke="#52525b"
          tick={{ fill: "#52525b", fontSize: 10, fontFamily: "JetBrains Mono" }}
          tickLine={false}
          axisLine={{ stroke: "#27272a" }}
          minTickGap={40}
        />
        <YAxis
          stroke="#52525b"
          tick={{ fill: "#52525b", fontSize: 10, fontFamily: "JetBrains Mono" }}
          tickLine={false}
          axisLine={{ stroke: "#27272a" }}
          domain={["auto", "auto"]}
          width={60}
        />
        <Tooltip
          contentStyle={{
            background: "#050505",
            border: "1px solid #27272a",
            borderRadius: 0,
            fontFamily: "JetBrains Mono",
            fontSize: 11,
            color: "#fff",
          }}
          labelStyle={{ color: "#8a8a8a" }}
          formatter={(v) => [`$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 4 })}`, "Price"]}
        />
        <Line
          type="linear"
          dataKey="price"
          stroke={color}
          strokeWidth={1.5}
          dot={false}
          isAnimationActive={false}
        />
        {sma20 && <ReferenceLine y={sma20} stroke="#FFD600" strokeDasharray="3 3" ifOverflow="extendDomain" />}
        {sma50 && <ReferenceLine y={sma50} stroke="#8A8A8A" strokeDasharray="3 3" ifOverflow="extendDomain" />}
      </ComposedChart>
    </ResponsiveContainer>
  );
}
